(function () {
    'use strict';

    angular.module('sempraWebapp').factory('layoutActions', layoutActionsFactory);

    /** @ngInject */
    function layoutActionsFactory (dispatcher, ActionTypesEnum) {
        return {
            showLoader: showLoader,
            hideLoader: hideLoader
        };

        function showLoader () {
            dispatcher.dispatch({
               type: ActionTypesEnum.SHOW_LOADER
            });
        }

        function hideLoader () {
            dispatcher.dispatch({
               type: ActionTypesEnum.HIDE_LOADER
            });
        }
    }
})();